import {Injectable} from '@angular/core';
import {BehaviorSubject} from 'rxjs';

@Injectable()
export class CustomLoadingService {
  public status: BehaviorSubject<boolean> = new BehaviorSubject(false);
  private _internalCounter = 0;

  constructor() {
  }

  public toggleLoading(status: boolean) {
    this.status.next(status);
  }

  public increment() {
    if (this._internalCounter === 0) {
      this.toggleLoading(true);
    }
    this._internalCounter++;
  }

  public decrement() {
    if (this._internalCounter === 1) {
      this.toggleLoading(false);
    }
    this._internalCounter--;
  }
}
